<template>
  <div id="js-floatheader-items-container" class="container menu-page">
    <template v-for="(val, i) in menu">
      <Menu
        v-if="val.show"
        :title="getCategoryTitle(val.id, val.name)"
        :id="val.slug"
        :key="val.slug"
        :type="val.slug"
        :items="val.menuItems"
        :collections="val.collections"
        :titleImg="val.ico"
        :description="getCategoryText(val.id)"
        :initialCompilationState="
				$route.params.name === val.slug
					? $route.params.compilation
					: null
			"
        :initialCompilationTitle="
				$route.params.name === val.slug
					? $route.params.compilationTitle
					: null
			"
        :initialDefaultCompilation="
				$route.params.name === val.slug
					? $route.params.defaultCompilation
					: null
			"
        class="menu-page__item js-floatheader-observer"
      />
    </template>
    <LoaderOverScreen v-if="hasMenuLoading" />
  </div>
</template>

<script>
import Menu from '@/components/page/Menu/Menu'
import LoaderOverScreen from '@/components/UI/LoaderOverScreen'
import { mapGetters } from 'vuex'

export default {
  components: { Menu, LoaderOverScreen },
  /* head () {
    return {
      title: this?.activeMenuItem?.metaTitle,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this?.activeMenuItem?.metaDescription,
        },
      ],
    }
  }, */
  data () {
    return {
      scrollBarWidth: 0,
      oldPosTop: 0,
      collectionsList: [],
      collection: null,
      initialCollection: [],
      timeout: null,
      categoriesText: [],
      categoriesTitle: [],
      /* nav: [
        { path: '/menu/rolls', name: 'Роллы', id: 'rolls' },
        { path: '/menu/sushi', name: 'Cуши', id: 'sushi' },
        { path: '/menu/sets', name: 'Сеты', id: 'sets' },
        { path: '/menu/pizza', name: 'Пицца', id: 'pizza' },
        { path: '/menu/combo', name: 'Комбо', id: 'combo' },
        { path: '/menu/salad', name: 'Салаты', id: 'salad' },
        { path: '/menu/soup', name: 'Супы', id: 'soup' },
        { path: '/menu/snacks', name: 'Закуски', id: 'snacks' },
        { path: '/menu/drinks', name: 'Напитки', id: 'drinks' },
        { path: '/menu/sauce', name: 'Соусы', id: 'sauce' },
      ], */
    }
  },
  computed: {
    ...mapGetters({
      text: 'seo/getText',
      title: 'seo/getPageTitle',
    }),
    collectionsTurnedOn () {
      return Boolean(this.collection)
    },
    activeMenuItem () {
      const result = this.menu.find(item => item.active)
      return result || {}
    },
  },
  watch: {
    text (newText) {
      const id = this?.activeMenuItem?.id ?? 0
      this.categoriesText[id] = newText
    },
    title (newTitle) {
      const id = this?.activeMenuItem?.id ?? 0
      this.categoriesTitle[id] = newTitle
    },
  },
  async asyncData ({ store, route, $axios, error }) {
    // Получим категории
    const api = store.getters['api/menuCategories']
    let menu = null
    const categoriesText = []
    const categoriesTitle = []
    let hasActiveCategory = false

    try {
      const resp = await $axios.get(api)
      menu = resp.data.items.map((item, index, arr) => {
        const active = item.slug === route.params.name
        const show = item.slug === route.params.name
        const prev = index > 0 ? arr[index - 1].slug : null
        const next = index < arr.length - 1 ? arr[index + 1].slug : null

        if (active) {
          hasActiveCategory = true
          store.commit('seo/setMetaFieldsDefaults', {
            metaTitle: `${item.name} | СУШИСЕТ`,
            metaDescription: ``,
            pageTitle: item.name,
          })
          categoriesText[item.id] = store.getters['seo/getText']
          categoriesTitle[item.id] = store.getters['seo/getPageTitle']
        }
        return { ...item, active, show, prev, next }
      })
    } catch {
      menu = []
    }

    if (!hasActiveCategory) {
      return error({ statusCode: 404, message: 'Категория не найдена' })
    }

    return { menu, hasMenuLoading: true, categoriesText, categoriesTitle }
  },
  mounted () {
    // блокировка отлипания шапки если мы не на первом элементе каталога
    // *********
    const currentItem = this.menu.find(item => item.active)
    if (currentItem?.prev) {
      this.$store.commit('setLockHeaderFloating', true)
    }

    this.scrollBarWidth = window.innerWidth - document.documentElement.clientWidth
    this.setActiveMenuItem(this.oldPosTop)

    // подскролл к ранее выбранному товару
    this.$nextTick(() => {
      setTimeout(() => {
        const id = window.localStorage.getItem('openedProduct')
        if (id) {
          window.localStorage.removeItem('openedProduct')
          const product = this.$el.querySelector(`#card${id}`)
          if (product) {
            const topPosition = product.getBoundingClientRect().top + window.pageYOffset
            const header = document.querySelector('.header')

            window.scrollTo({ top: topPosition - header.clientHeight - 20, behavior: 'smooth' })
          }
        } else {
          window.scrollTo({ top: window.innerWidth >= 769 ? 100 : 50 })
        }

        // После того как отрендерим каталог, повесим обсервер на установку активного элемента меню
        window.addEventListener('scroll', this.observeFloatHeaderNavigation)

        this.oldPosTop = this.getScrollTop()
        this.hasMenuLoading = false
      }, 100)
    })
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.observeFloatHeaderNavigation)
    this.$store.commit('setLockHeaderFloating', false)
  },
  methods: {
    setPageMeta (category, newUrl) {
      this.$store
        .dispatch('seo/fetchPageMeta', {
          pageUrl: newUrl,
          regionId: this.$region.getCurrentRegionId(),
        })
        .then(() => {
          this.$store.commit('seo/setMetaFieldsDefaults', {
            metaTitle: `${category.name} | СУШИСЕТ`,
            metaDescription: ``,
            pageTitle: category.name,
          })
        })
    },
    getCategoryText (id) {
      if (id && this.categoriesText[id]) {
        return this.categoriesText[id]
      }
    },
    getCategoryTitle (id, defaultValue) {
      if (id && this.categoriesTitle[id]) {
        return this.categoriesTitle[id]
      }
      return defaultValue
    },
    getScrollTop () {
      return window.pageYOffset !== undefined
        ? window.pageYOffset
        : (
          document.documentElement ||
          document.body.parentNode ||
          document.body
        ).scrollTop
    },
    setActiveMenuItem (posTop) {
      const elements = document.getElementsByClassName('js-floatheader-observer')

      elements.forEach((element) => {
        const elementTop = element.getBoundingClientRect().top + posTop
        const elementBottom = elementTop + element.offsetHeight
        const centerPage = posTop + window.innerHeight / 2

        if (!this.hasMenuLoading) {
          // установка активнгого элемента в зоне видимости
          if (centerPage >= elementTop && centerPage <= elementBottom && this.getScrollTop() > 0) {
            const elementId = element.getAttribute('id')

            this.$store.dispatch('menu/setActiveMenu', elementId)
            this.menu = this.menu.map((item) => {
              const active = item.slug === elementId
              const url = location.href.split('/')
              const urlActive = url[url.length - 1]
              if (active && item.slug !== urlActive) {
                // console.log('--', item.name, '--')
                const newUrl = `/menu/${item.slug}`
                history.replaceState({}, '', newUrl)
                this.setPageMeta(item, newUrl)
              }
              return { ...item, active }
            })
          }
        }
      })
    },
    observeFloatHeaderNavigation () {
      const posTop = this.getScrollTop()
      this.setActiveMenuItem(posTop)

      const currentItem = this.menu.find(item => item.active)
      // скролл вверх
      if (this.oldPosTop >= posTop) {
        // разблакировка залипания шапки на первом элементе каталога
        if (!currentItem.prev) {
          this.$store.commit('setLockHeaderFloating', false)
        }

        if (posTop <= 0 && !this.hasMenuLoading) {
          if (currentItem.prev) {
            this.hasMenuLoading = true

            // обновление состояний элементов каталога
            this.menu = this.menu.map((item) => {
              const show = item.slug === currentItem.prev
              return { ...item, show: show ? true : item.show }
            })
            const headerHeight = document.querySelector('.header').offsetHeight
            const currentDomItem = document.querySelector('#' + currentItem.slug)

            this.$nextTick(() => {
              // подскролл к активному элементу
              this.lockScroll()

              const scrollPosition = currentDomItem.getBoundingClientRect().top - headerHeight - 100
              this.timeout = setInterval(() => {
                if (this.getScrollTop() !== scrollPosition) {
                  window.scrollTo({ top: scrollPosition })
                }
              }, 50)

              setTimeout(() => {
                this.unLockScroll()
                clearInterval(this.timeout)
                this.hasMenuLoading = false
              }, 1000)
            })
          }
        }
        // скролл вниз
      } else {
        const currentDomItem = document.querySelector('#' + currentItem.slug)
        const currentDomItemBottom = currentDomItem.getBoundingClientRect().top + posTop + currentDomItem.offsetHeight

        if (posTop + window.innerHeight >= currentDomItemBottom - window.innerHeight / 2) {
          if (currentItem.next) {
            this.menu = this.menu.map((item) => {
              const show = item.slug === currentItem.next
              return { ...item, show: show ? true : item.show }
            })
          }
        }
      }
      this.oldPosTop = posTop
    },
    lockScroll () {
      document.querySelector('.header').style.paddingRight = this.scrollBarWidth + 'px'
      document.documentElement.style.paddingRight = this.scrollBarWidth + 'px'
      document.documentElement.style.overflow = 'hidden'
      document.body.style.overflow = 'hidden'
    },
    unLockScroll () {
      document.querySelector('.header').style.paddingRight = ''
      document.documentElement.style.paddingRight = ''
      document.documentElement.style.overflow = 'auto'
      document.body.style.overflow = 'auto'
    },
  },
}
</script>

<style lang="less">
.menu-page {
  min-height: 100vh;

  @media (max-width: 768px) {
    padding-top: 50px;
  }

  .loader-ovescreen {
    position: fixed;
    background-color: rgba(255, 255, 255, .8);
    backdrop-filter: blur(20px);
  }
}

.menu-page__item {
  @media (min-width: 992px) {
    margin-bottom: 20px;
  }
}

.menu {
  &:not(:last-child) {
    margin-bottom: 44px;
  }

  &:last-child {
    margin-bottom: 20px;
  }

  &_title {
    margin-bottom: 33px;
  }

  &_description {
    margin-bottom: 50px;

    p {
      font-family: 'Roboto', Arial, sans-serif;
      font-weight: 300;
      font-size: 14px;
      line-height: 18px;
    }
  }
}
</style>
